var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.$attrs.site_key),expression:"$attrs.site_key"}],attrs:{"cols":"12"}},[_c('Site',{attrs:{"site-key":_vm.$attrs.site_key}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }